var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "features-widget-component", class: [_vm.activeTab] },
    [
      _vm.isCarouselMode
        ? _c(
            "div",
            {
              staticClass: "features-header",
              on: {
                click: function($event) {
                  return _vm.collapseExpand()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "tab-switcher" },
                _vm._l(_vm.availableFeatureTabs, function(tab) {
                  return _c(
                    "div",
                    {
                      key: tab,
                      staticClass: "tab-item",
                      class: { active: _vm.activeTab === tab },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.switchTab(tab)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "icon", class: [tab] }),
                      _vm._v(" "),
                      _c("span", { staticClass: "feature-title" }, [
                        _vm._v(_vm._s(_vm.getTabLabel(tab)))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "features-right-side" },
                [
                  _vm.isLoading ? _c("circle-loader") : _vm._e(),
                  _vm._v(" "),
                  (_vm.mobileBigAndBelow && !_vm.isLoading) ||
                  !_vm.mobileBigAndBelow
                    ? _c("div", { staticClass: "features-arrow-icon" }, [
                        _c(
                          "i",
                          {
                            staticClass: "v-icon material-icons theme--light",
                            attrs: { "aria-hidden": "true" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.expansionPanel === 0
                                  ? "keyboard_arrow_down"
                                  : "keyboard_arrow_up"
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        {
          staticClass: "features-holder",
          model: {
            value: _vm.expansionPanel,
            callback: function($$v) {
              _vm.expansionPanel = $$v
            },
            expression: "expansionPanel"
          }
        },
        [
          _c(
            "v-expansion-panel-content",
            { attrs: { disabled: !_vm.isCarouselMode } },
            [
              _c(
                "v-card",
                { staticClass: "features-content" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in", appear: "" } },
                    [
                      _c(
                        "keep-alive",
                        [
                          _c(
                            _vm.componentMap[_vm.activeTab],
                            _vm._b(
                              {
                                key: _vm.componentMap[_vm.activeTab],
                                tag: "component"
                              },
                              "component",
                              _vm.getPropsForTab(_vm.activeTab),
                              false
                            )
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e85f02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e85f02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/featureTabsWidget/featureTabsWidget.vue
// module id = null
// module chunks = 